export const createHtmlDocument = (data: string): Document => {
  return new DOMParser().parseFromString(data, 'text/html');
};
